import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { TweenMax, TimelineMax, CSSPlugin, Expo } from 'gsap/all';
import DrawSVGPlugin from '../gsap-bonus/DrawSVGPlugin';
import ScrollMagic from 'scrollmagic';



import '../styles/components/big-card.scss';

import poster1 from '../assets/poster1.jpg';



export default class BigCard extends Component {


    constructor(props) {
      super(props);
      this.trigger = null;
      this.bigTitle = null;
      this.bcStroke = null;
      this.poster1 = null;
    }

    componentDidMount() {
      TweenMax.set(this.bcStroke, {
        drawSVG: 0,
        visibility: 'visible'
      })

      TweenMax.set(this.poster1, {
        opacity: 0
      })

      const bigCardTl = new TimelineMax({paused: true});
      bigCardTl.to(this.bcStroke, 1.5, {
        drawSVG: '100%',
        ease: Expo.easeInOut
      })
      .to(this.poster1, 0.5, {
        opacity: 1
      }, '-=0.125')
      .to(this.bcStroke, 0.5, {
        opacity: 0
      }, '-=0.25')

      const bigCardController = new ScrollMagic.Controller();
      const bigCardScene = new ScrollMagic.Scene({
        triggerElement: this.trigger,
        triggerHook: "onLeave",
        reverse: true
      }).addTo(bigCardController);

      bigCardScene.on("enter", function (event) {
        bigCardTl.play();
      });
    }

    render() {

        return (
          <div className="big-card">
            <span className="trigger" ref={span => this.trigger = span} />
            <span className="small-title">INTRODUCING THE NEW VIVE&trade;</span>
            <span className="big-title" ref={span => this.bigTitle = span}>Discover a New World <br />of Unexpected <br /> Gaming</span>
            <span className="border" />
            <div className="image-area">
              <div className="image-group">
                <img  src={poster1} ref={img => this.poster1 = img} alt='Robocall Image' />
                <svg viewBox="0 0 604 404">
                  <path ref={path => this.bcStroke = path} d="M600.51,7a6,6,0,0,1,6,6V401a6,6,0,0,1-6,6h-588a6,6,0,0,1-6-6V13a6,6,0,0,1,6-6h588.8" transform="translate(-4.5 -5)"/>
                </svg>
              </div>
              <div className="info">
                <span>Entertainment in New and <br />Extraordinary Ways</span>
                <p>Redefine your expectations of immersion in gaming with moments so intense your intuition takes over. Step into incredible virtual worlds and experience.</p>
                <div className="more">
                  <span />
                  <Link to='/'><p>Learn More</p></Link>
                </div>
              </div>
            </div>
          </div>
        );
    }
}
